




























































































import {
  defineComponent,
  reactive,
  ref,
  watch,
  computed,
} from '@vue/composition-api'
import moment from 'moment'
import { VueLoading } from 'vue-loading-template'

import { UserState, QuestionnaireAnswerState } from '@/types/store'

import useVuex from '@/utils/useVuex'

import { ReceiptView } from '@/components/molecules'
import { FileView } from '@/components/molecules'
import Layout from '@/components/organisms/common/Layout.vue'
import AnswerTable from '@/components/organisms/questionnaire-answer/AnswerTable.vue'
import AnswerInputTable from '@/components/organisms/questionnaire-answer/AnswerInputTable.vue'
import MetaTable from '@/components/organisms/questionnaire-answer/MetaTable.vue'
import QuestionnaireAnswerActions from '@/components/organisms/questionnaire-answer/QuestionnaireAnswerActions.vue'
import { AnswerSummary } from '@/types/questionnaire-answer'
import { QuestionType } from '@/types/questionnaire'
import { QuestionnaireAnswerEntity } from '../../../api/@types'

export default defineComponent({
  name: 'QuestionnaireAnswer',
  components: {
    ReceiptView,
    FileView,
    Layout,
    VueLoading,
    AnswerTable,
    AnswerInputTable,
    MetaTable,
    QuestionnaireAnswerActions,
  },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      workStartedMoment: moment(),
      questionnaireAnswer: useVuex<
        QuestionnaireAnswerState['questionnaireAnswer']
      >(
        context,
        () => store.getters['questionnaireAnswer/questionnaireAnswer'],
      ),
      receipt: useVuex<QuestionnaireAnswerState['receipt']>(
        context,
        () => store.getters['questionnaireAnswer/receipt'],
      ),
      answerSummaries: useVuex(
        context,
        () => store.getters['questionnaireAnswer/answerSummaries'],
      ),
      loading: false,
    })
    const summaries = ref<(AnswerSummary & { source: string })[]>(
      state.answerSummaries.map((item: AnswerSummary) => {
        return { ...item, source: item.answerText }
      }),
    )
    // For dynamic receipt view height
    const receiptViewHeight = ref<number>(0)
    const reflectAnswerInput = (
      defectReason: string | null,
      messageToAdmin: string | null,
    ) => {
      state.questionnaireAnswer.defectReason = defectReason
      state.questionnaireAnswer.messageToAdmin = messageToAdmin
    }
    const changeReceitViewHeight = () => {
      setTimeout(() => {
        const rightCol = document.querySelector('.QuestionnaireAnswer_RightCol')
        receiptViewHeight.value = rightCol ? rightCol.scrollHeight - 76 : 0
      }, 100)
    }
    watch(
      [() => state.receipt?.id, () => state.questionnaireAnswer?.id],
      () => {
        if (state.receipt !== null && state.questionnaireAnswer !== null) {
          state.loading = false
          changeReceitViewHeight()
        }
      },
    )
    changeReceitViewHeight()

    // Erros
    const apiError = ref<string>('')
    watch(
      () => state.questionnaireAnswer,
      () => {
        apiError.value = ''
      },
    )
    const onClickApiErrorClose = () => {
      apiError.value = ''
    }

    // logger
    watch(
      () => state.questionnaireAnswer?.id,
      () => {
        state.workStartedMoment = moment()
      },
    )

    const title = `${
      state.questionnaireAnswer?.questionnaire.isAutomatic ? '自動' : '手動'
    }アンケートチェック`

    const onClickFinishWithSave = async () => {
      state.loading = true
      try {
        // await finishQuestionnaireAnswer() // @todo
        context.root.$router.push('/').catch(() => {
          /*2連打した際のerrorを無視*/
        })
      } catch (error) {
        console.error(error)
      }
    }
    const onClickFinishWithoutSave = () => {
      context.root.$router.push('/').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }
    const onClickGoBackWithoutSave = () => {
      context.root.$router.go(-1)
    }

    const finishQuestionnaireAnswer = async () => {
      const updateItems = summaries.value.filter(item => {
        return (
          (item.type === QuestionType.TEXT &&
            item.answerText !== item.source) ||
          (item.type === QuestionType.TEXT_AREA &&
            item.answerText !== item.source)
        )
      })
      updateItems.length > 0 &&
        (await store.dispatch(
          'questionnaireAnswer/updateQuestionAnswer',
          updateItems,
        ))
      if (state.questionnaireAnswer.defectReason === '') {
        state.questionnaireAnswer.defectReason = null
      }
      if (state.questionnaireAnswer.messageToAdmin === '') {
        state.questionnaireAnswer.messageToAdmin = null
      }
      await store.dispatch('questionnaireAnswer/updateCheckStatus', {
        questionnaireAnswer: state.questionnaireAnswer,
        userRole: state.user?.role,
      })
      // await store.dispatch('qlog/createLog', {
      // castId: user.castId,
      // castName: user.castName,
      // workerType: user.role,
      // workedAt: now.toDate(),
      // workDuration: now.diff(state.workStartedMoment, 'seconds'),
      // workTarget: log[0],
      // workResult: log[1],
      // note: '',
      // specialOfferReceiptId: specialOfferReceipt.id,
      // workedById: user.id,
      // })
    }

    const isLastQuestionnaireAnswer = computed(
      () => store.getters['questionnaireAnswer/nextAnswerId'] === null,
    )

    const onClickNextQuestionnaireAnswer = async () => {
      state.loading = true
      try {
        await finishQuestionnaireAnswer()
        if (!isLastQuestionnaireAnswer.value) {
          const nextAnswerId = store.getters['questionnaireAnswer/nextAnswerId']
          const nestQa: QuestionnaireAnswerEntity = await store.dispatch(
            'questionnaireAnswer/getQuestionnaireAnswer',
            nextAnswerId,
          )
          if (nestQa.receiptId && Number(nestQa.receiptId)) {
            await store.dispatch(
              'questionnaireAnswer/getReceipt',
              nestQa.receiptId,
            )
          }
          state.loading = false
        } else {
          context.root.$router.go(-1)
        }
      } catch (error) {
        console.error(error)
      }
    }

    const updateQuestionnaireAnswer = (
      questionnaireAnswer: QuestionnaireAnswerEntity,
    ) => {
      state.questionnaireAnswer = questionnaireAnswer
    }

    const fileAnswers = computed(() => {
      if (!state.questionnaireAnswer) {
        return []
      }
      return state.questionnaireAnswer.questionAnswers.filter(
        qa => qa.type === 'file',
      )
    })

    return {
      state,
      summaries,
      receiptViewHeight,
      apiError,
      onClickApiErrorClose,
      title,
      reflectAnswerInput,
      onClickFinishWithSave,
      onClickFinishWithoutSave,
      onClickGoBackWithoutSave,
      isLastQuestionnaireAnswer,
      onClickNextQuestionnaireAnswer,
      updateQuestionnaireAnswer,
      fileAnswers,
    }
  },
})
